// extracted by mini-css-extract-plugin
export default {"reservationList":"customer_reservationList__dXH3Z","customerList":"customer_customerList__S+6rb","feedbackList":"customer_feedbackList__pwXSJ"};